@if (wrapper) {
  <div [ngClass]="wrapperDivClasses">
    @for (noteCategory of ['danger', 'info', 'success']; track $index) {
      @if (wrapper[noteCategory]) {
        @for (item of wrapper[noteCategory]; track item.id) {
          <ngb-alert [type]="noteCategory" [dismissible]="dismissibleNotes" (closed)="closeNote(item, noteCategory)">
            <div [innerHTML]="item.note"></div>
            <div class="d-flex justify-content-end">
              @if (dismissibleNotes) {
                <div class="custom-control custom-checkbox checkbox--alert">
                  <input type="checkbox" [id]="'note' + item.id" class="custom-control-input" (change)="toggleNote($event, item)" />
                  <label [for]="'note' + item.id" [class]="'custom-control-label custom-control-label--' + noteCategory">
                    nicht mehr anzeigen
                  </label>
                </div>
              }
            </div>
          </ngb-alert>
        }
      }
    }
    @if (wrapper['custom']) {
      @for (item of wrapper['custom']; track item.id) {
        <div [innerHTML]="item.note"></div>
      }
    }
  </div>
}
